import StandardProductOptionsHeader from "entities/configurator/standard-product-header";
import { StandardProductCategory } from "shared/api/middleware-api-client";
import OptionTemplate from "shared/ui/option-template";
import { USPMetaDataType } from "shared/utils/usps";
import { OptionModalState } from "widgets/configurator/option-modal";
import { StandardProductsProductList } from "./StandardProductsProductList";
import { memo } from "react";
import { StandardProductsColorProductList } from "./StandardProductsColorProductList";
import WhatsappWidget from "widgets/shared/whatsapp-widget";

interface Props {
  setOptionModalState: (state: OptionModalState) => void;
  additionalData: USPMetaDataType;
  selectedCategory: StandardProductCategory;
}
export const StandardOptionsGeneralTemplate = memo(
  ({ setOptionModalState, additionalData, selectedCategory }: Props) => {
    const isColor = selectedCategory?.code === "verfset";

    return (
      <>
        <StandardProductOptionsHeader
          title={selectedCategory?.name ?? ""}
          code={selectedCategory?.code}
          description={selectedCategory?.description ?? ""}
        />

        <WhatsappWidget />

        <OptionTemplate
          title={additionalData.title}
          testId={`standard-product-${selectedCategory?.code}-option`}
          showInfo={selectedCategory.code !== "gereedschap"}
          onShowInfoClick={() =>
            setOptionModalState({
              isOpen: true,
              heading: additionalData.information_title,
              description: additionalData.information_description,
            })
          }
        >
          {!isColor ? (
            <StandardProductsProductList selectedCategory={selectedCategory} />
          ) : (
            <StandardProductsColorProductList
              selectedCategory={selectedCategory}
            />
          )}
        </OptionTemplate>
      </>
    );
  }
);
